<template>
    <div class="container">
        <el-dialog
            title="置业顾问详情"
            :visible.sync="showpicker"
            width="1200px"
            @close="back">
            <div class="user-box">
                <el-row :gutter="20">
                    <el-col class="user-box-col" :span="16" :offset="0">
                        <div class="item-box">
                            <div class="item-warp">
                                <div class="item-cell">
                                    <div class="img-box">
                                        <el-image class="img" :src="broker.ltpic" fit="contain" :lazy="true"></el-image>
                                    </div>
                                    <div class="warp">
                                        <p class="text">
                                            <span class="label">姓名</span>
                                            <span class="info">{{broker.name}}</span>
                                            <span class="info">{{broker.telephone}}</span>
                                        </p>
                                        <p class="text">
                                            <span class="label">身份证</span>
                                            <span class="info">{{broker.idcard}}</span>
                                        </p>
                                        <p class="text">
                                            <span class="label">微信</span>
                                            <span class="info">{{broker.wechat}}</span>
                                        </p>
                                        <p class="text">
                                            <span class="label">标签</span>
                                            <el-tag class="tag" type="info" size="mini"  effect="dark" v-for="(tag, ind) in broker.tags" :key="ind">{{tag}}</el-tag>
                                        </p>
                                        <p class="text">
                                            <span class="label">从业经历</span>
                                            <span class="info">{{broker.experience}}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="item-cell">
                                    <div class="img-box">
                                        <el-image class="img" :src="broker.certificate" fit="contain" :lazy="true"></el-image>
                                    </div>
                                    <div class="warp">
                                        <p class="text">
                                            <span class="label">公司</span>
                                            <span class="info">{{broker.company}}</span>
                                        </p>
                                        <p class="text">
                                            <span class="label">团队类型</span>
                                            <span class="info">{{broker.team}}</span>
                                        </p>
                                        <p class="text">
                                            <span class="label">关联楼盘</span>
                                            <span class="info">{{broker.projectname}}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="item-cell" v-if="team">
                                    <div class="warp">
                                        <p class="text">
                                            <span class="label">团队</span>
                                            <span class="info">{{team.name}}</span>
                                            <span class="info link-text">查看详情</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="item-cell">
                                    <div class="btn-box">
                                        <el-button class="btn" type="warning" size="small" v-if="consultant&&consultant.putaway==true" @click="setputaway(false)">下架</el-button>
                                        <el-button class="btn" type="success" size="small" v-if="consultant&&consultant.putaway==false" @click="setputaway(true)">上架</el-button>
                                        <el-button class="btn" type="primary" size="small" v-if="!consultant&&(broker.status=='01'||broker.status=='02')" @click="pass">通过审核</el-button>
                                        <el-popover
                                            placement="top"
                                            width="300"
                                            trigger="click"
                                            v-if="!consultant&&(broker.status=='01'||broker.status=='02')"
                                            v-model="visible">
                                            <div class="popver-box">
                                                <el-input class="custom-input" type="textarea" v-model="reason" placeholder="请填写不通过理由" size="normal" clearable></el-input>
                                                <div class="btn-box">
                                                    <el-button type="default" size="small" @click="visible=false">取消</el-button>
                                                    <el-button type="primary" size="small" @click="nopass">提交</el-button>
                                                </div>
                                            </div>
                                            <el-button class="btn" type="danger" size="small" slot="reference">不通过</el-button>
                                        </el-popover>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col class="user-box-col" :span="8" :offset="0">

                    </el-col>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showpicker: true,
            uid: '',
            broker: '',
            consultant: '',
            reason: '',
            visible: false,
            team: '',
        }
    },
    created () {
        this.uid = this.$route.query.uid;
        if (this.uid){
            this.getConsultantdetailVsuid();
        }
    },
    methods: {
        setputaway(putaway) {
            var params = {
                id: this.consultant._id['$oid'],
                putaway
            }
            this.$api.consultantPutawayVsId(params).then(
                data=>{
                    this.$message.success(data);
                    this.consultant.putaway = putaway;
                }
            )
        },
        pass() {
            var params = {
                id: this.broker._id['$oid']
            }
            this.$api.consultantbrokerpass(params).then(
                data=>{
                    this.$message.success(data);
                    this.getConsultantdetailVsuid();
                }
            )
        },
        nopass() {
            if (!this.reason) {
                this.$alert('请填写不通过理由');
                return;
            }
            var params = {
                id: this.broker._id['$oid'],
                reason: this.reason,
            }
            this.$api.consultantbrokernopass(params).then(
                data=>{
                    this.$message.success(data);
                    this.getConsultantdetailVsuid();
                }
            )
        },
        getConsultantdetailVsuid() {
            var params = {
                uid: this.uid,
            }
            this.$api.getConsultantdetailVsuid(params).then(
                data=>{
                    let {broker, consultant, team} = data;
                    if (broker.tags.indexOf('[')>-1){
                        broker.tags = JSON.parse(broker.tags)
                    }
                    if (broker.ltpic.indexOf('[')>-1){
                        broker.ltpic = JSON.parse(broker.ltpic)[0];
                    }
                    this.broker = broker;
                    this.consultant = consultant;
                    this.team = team;
                }
            )
        },
        back() {
            this.$router.go(-1);
        }
    },
}
</script>

<style lang="scss" scoped>
.user-box{
    padding: 10px;
    .user-box-col{
        border-right: 1px solid #dddddd;
        padding: 10px;
        box-sizing: border-box;
        background: #f7f7f7;
        &:last-child{
            border-right: none;
        }
        .item-box{
            .item-warp{
                background: #f7f7f7;
                .item-cell{
                    background: #fff;
                    margin-bottom: 14px;
                    padding: 10px;
                    position: relative;
                    overflow: hidden;
                    &:last-child{
                        margin-bottom: 0;
                    }
                    .img-box{
                        float: left;
                        margin-right: 10px;
                        .img{
                            width: 100px;
                            height: 130px;
                            border: 1px dashed #eee;
                            box-sizing: border-box;
                        }
                    }
                    .warp{
                        float: left;
                        .text{
                            margin-bottom: 2px;
                            &:last-child{
                                margin-bottom: 0;
                            }
                            .label{
                                display: inline-block;
                                width: 80px;
                                text-align: right;
                                margin-right: 10px;
                                color: #999;
                            }
                            .info{
                                margin-right: 10px;
                                &:last-child{
                                    margin-right: 0;
                                }
                            }
                            .tag{
                                margin-right: 2px;
                                &:last-child{
                                    margin-right: 0;
                                }
                            }
                        }
                    }
                    .btn-box{
                        text-align: right;
                        .btn{
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
    }
}
.popver-box{
    .custom-input{
        ::v-deep.el-textarea__inner{
            height: 100px;
        }
    }
    .btn-box{
        text-align: right;
        margin-top: 10px;
    }
}
</style>